import type { Component } from 'vue'

import { ICONS } from '#utils/icons'

export interface NavItem {
  to: string
  label: string
  icon: Component
}

export const NAV: { label: string; items: NavItem[] }[] = [
  {
    label: 'Operations',
    items: [
      { to: '/jobs', label: 'Jobs', icon: ICONS.jobs },
      { to: '/cron', label: 'Cron', icon: ICONS.crons },
      { to: '/enrichment-ai', label: 'Enrichment AI', icon: ICONS.enrichmentAi },
      { to: '/file-uploads', label: 'File uploads', icon: ICONS.fileUploads },
    ],
  },
  {
    label: 'Content',
    items: [
      { to: '/skills', label: 'Skills', icon: ICONS.skills },
      { to: '/chats', label: 'Chats', icon: ICONS.chats },
    ],
  },
  {
    label: 'Customers',
    items: [{ to: '/customers', label: 'Customers', icon: ICONS.customers }],
  },
  {
    label: 'Taxonomy',
    items: [
      {
        to: '/qualitative-data-suppliers',
        label: 'Supplier Dimensions',
        icon: ICONS.supplierDimensions,
      },
      {
        to: '/qualitative-data-projects',
        label: 'Project Dimensions',
        icon: ICONS.projectDimensions,
      },
    ],
  },
]
